export enum Reference {
    Gender = "gender",
    Country = "country",
    Nationality = "nationality",
    Languages = "language",
    TaxStatus = "taxStatus",
    PersonTitle = "personTitle",
    LegalStatus = "legalStatus",
    RelationType = "relationType",
    MaritalStatus = "maritalStatus",
    SocialStatus = "socialStatuses",
    PhoneNumberType = "phoneNumberType",
    BankAccountType = "bankAccountType",
    DriverLicenseType = "driversLicenseType",
    AdditionalTaxStatus = "additionalTaxStatus",
    PersonTitleSchool = "personTitleSchoolClaim",
    BrokenGlasses = "brokenGlasses",
    Nature = "nature",
    DamageType = "damageType",
    Place = "place",
    ArchitectType = "architectType",
    WorkNature = "workNature",
}
